//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { fetch, store, update } from '@/apis/activity'

import { oss_files } from '@/apis/config'


export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            name: [{ required: true, message: '請輸入名稱！' }],
            image: [{ required: true, message: '請上傳封面圖！' }],
            // pcImage: [{ required: true, message: '請上傳PC封面圖！' }],
            author: [{ required: true, message: '請輸入主辦方！' }],
            remark: [{ required: true, message: '請輸入活動介紹！' }],
            
        };
        const formData = {
            image: "",
            pcImage: "",
            name: "",
            status: "1",
            viewTotal: "",
            favoriteTotal: "",
            num: "",
            amount: "",
            author: "",
            videoUrl: "",
            remark:"",

        };
        return {
            id: 0,
            fileLoading: false,
            pcfileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            pcfileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {
                    this.formData = res.data;
                    this.formData.status = this.formData.status.toString();
                    this.onLoadFile();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            if (this.formData.image) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(this.formData.image),
                    status: 'done',
                    url: this.formData.image,
                    thumbUrl: this.formData.image,
                }]
            }
            if (this.formData.pcImage !== undefined && this.formData.pcImage) {
                this.pcfileList = [{
                    uid: '-2',
                    name: getFileName(this.formData.pcImage),
                    status: 'done',
                    url: this.formData.pcImage,
                    thumbUrl: this.formData.pcImage,
                }]
            }
        },

        //圖片上傳
        async handleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);

                    if (res.code == 0) {
                        this.formData.image = res.data;
                        this.fileList = validFiles;
                        this.$refs.imageValidate.clearValidate();

                    } else {
                        this.$message.error(res.msg);
                    }
                    console.log(`output->this.formData`, this.formData)
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.formData.image = "";
            }
        },
        async pchandleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.pcfileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);

                    if (res.code == 0) {
                        this.formData.pcImage = res.data;
                        this.pcfileList = validFiles;
                        this.$refs.pcimageValidate.clearValidate();

                    } else {
                        this.$message.error(res.msg);
                    }
                    console.log(`output->this.formData`, this.formData)
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.pcfileLoading = false;
                }
            } else {
                this.pcfileList = fileList;
                this.formData.pcImage = "";
            }
        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },

        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.formData };
            if (this.id > 0) {
                form.id = this.id;
                formFunction = update;
            } else {
                formFunction = store;
            }
            try {
                this.spinning = true;
                const res = await formFunction(form);
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/activity');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
